var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFontType)?_c('font-icon',_vm._g(_vm._b({attrs:{"icon":_vm.icon,"color":_vm.color,"size":_vm.size,"width":_vm.width,"height":_vm.height}},'font-icon',_vm.$attrs,false),_vm.$listeners)):_c('svg-icon',_vm._g(_vm._b({attrs:{"icon":_vm.icon}},'svg-icon',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }